// The awards on a saved order, as the staff reads them.
//
// An order's awards are decided when it is created, so on an order that already
// exists the three input fields have nothing to edit -- anything typed into them
// would be dropped by awardIntake. This is what the vendor section shows there
// instead.
//
// DIRECTION COMES FROM `intent`, NOT FROM THE SIGN. This is the whole reason
// the award stores it: 贈送點數 -12 is a clawback on a return and stores exactly
// the same `{ point, -12 }` as 折抵點數 12, so reading the sign would show one
// as the other. The labels are the same 贈送 / 折抵 words that were on the boxes,
// so the record reads back the way it was entered.

const DIRECTION = {
  point: { earn: '贈送點數', spend: '折抵點數' },
  credit: { earn: '贈送購物金', spend: '折抵購物金' },
}

// Orders written before `intent` existed have none. Falling back to the sign is
// what those were displayed by anyway, so it is no worse than before -- and it
// keeps an old order readable instead of blank.
const intentOf = award =>
  award.intent || (Number(award.value) < 0 ? 'spend' : 'earn')

const UNKNOWN_TYPE = '不明項目'

// The state machine on the award, in the words a human needs:
//
//   adjustedAt        applied
//   adjustingAt       due, or claimed until it passes
//   neither           given up -- needs a human
//
// `失敗` deliberately does not say "will retry", because it will not. Recovery
// is a person putting a date back into adjustingAt.
function statusOf(award) {
  if (award.adjustedAt) return '已完成'
  if (award.adjustingAt) return '處理中'

  return '失敗'
}

function labelOf(award) {
  const words = DIRECTION[award.type]
  if (!words) return UNKNOWN_TYPE

  return words[intentOf(award)] || UNKNOWN_TYPE
}

// [] for an order with none, which is every order before it is saved and every
// order whose customer is not a member.
export default function awardRows(doc) {
  const awards = doc && Array.isArray(doc.awards) ? doc.awards : []

  return awards.map((award, index) => ({
    index,
    label: labelOf(award),
    // The magnitude, because the label already carries the direction.
    amount: Math.abs(Number(award.value) || 0),
    note: award.note || '',
    status: statusOf(award),
    // Diagnostic, shown only when there is one. It is provider text, so it may
    // be long and is not something the staff can act on beyond reporting it.
    error: award.error || '',
  }))
}

export { statusOf, labelOf }
